
import { filter } from 'rxjs/operators';
import { Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ReleaseStatus } from '../../../../api/wire/enums/release-status.enum';
import { WireActionTypeEnum } from '../../../../api/wire/enums/wire-action-type.enum';
import { DeliverySchedule, ScheduleType } from '../../../../Common/Forms/components/DeliveryScheduleInput/models/delivery-schedule';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { AmplifyRoutingService } from '../../../Core/services/amplify-routing.service';
import { WireModel } from '../../models/wire.model';
import { WirePageBuilderService } from '../../services/wire-page-builder.service';
import { WireService } from '../../services/wire.service';
import { ResourceActionTypes } from '../../../../Common/Basic/enums/resource-actions.enum';

@Component({
    selector: 'agpr-wire-confirm-dialog',
    templateUrl: './wire-confirmation.component.html',
    styleUrls: ['./wire-confirmation.component.scss'],
    standalone: false
})
export class WireConfirmationComponent extends AbstractDialogComponent implements OnDestroy {

    @Input() editorialMode = false;
    @Input() heading: string = 'Amplify.wire.confirmation.submit.heading';
    @Input() disclaimer: string = 'Amplify.wire.confirmation.submit.disclaimer1';
    @Input() additionalDisclaimer: string;

    wire: WireModel;
    scheduledTime;
    deliveryTime: string;
    disclaimerApproved: boolean = false;
    timezone: string;

    public readonly buttonTypes = ButtonTypesEnum;
    public readonly messageSeverityEnum = messageSeverityEnum;

    subscriptions: Subscription[] = [];

    loading = false;

    constructor(
        public coreDialogService: CoreDialogService,
        public amplifyRoutingService: AmplifyRoutingService,
        public wireService: WireService,
        public currentUserStateService: CurrentUserStateService,
        public wirePageBuilderService: WirePageBuilderService
    ) {
        super(coreDialogService, 'WireConfirmation');
        this.subscriptions.push(
            this.wireService.currentResource$.pipe(filter(x => !!x)).subscribe(wire => {
                this.wire = wire;
                this.formatScheduleTime();
            }),
            this.wireService.loading$.subscribe(x => this.loading = x),
            this.currentUserStateService.getPreferences().pipe(filter(x => !!x)).subscribe(prefs => {
                this.timezone = prefs?.timeZone;
                this.formatScheduleTime();
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    submitWire() {
        this.wirePageBuilderService.deselectBlock(true);

        if (this.editorialMode) {
            this.wireService.publish(this.wire, this.wirePageBuilderService.getWireHtml());
        } else {
            this.wire.status = ReleaseStatus.submitted;
            if (!this.wire.id) {
                this.wireService.createResource(this.wire, {actionType: ResourceActionTypes.SUBMIT, refreshResource: true}).subscribe(() => {
                    // AD-15472 - REMOVE AFTER WE FIX WEBSOCKETS
                    this.wireService.refreshWireList();
                });
            } else {
                this.wireService.updateWire(this.wire, {actionType: ResourceActionTypes.SUBMIT, refreshResource: true}).subscribe(() => {
                    // AD-15472 - REMOVE AFTER WE FIX WEBSOCKETS
                    this.wireService.refreshWireList();
                });
            }
        }

        this.closeDialog();
    }

    formatScheduleTime() {
        let scheduleTime = this.wire.deliverySchedule;
        if (scheduleTime.scheduleType === ScheduleType.immediate) {
            scheduleTime = new DeliverySchedule(new Date(), this.timezone);
        };

        this.scheduledTime = scheduleTime.getDisplayString().split(' ');
        this.scheduledTime = this.scheduledTime.join(' ');
    }
}
